import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Product } from '../../../models/product';

@Component({
  selector: 'alg-next-steps',
  templateUrl: './alg-next-steps.component.html',
  styleUrls: ['./alg-next-steps.component.scss']
})
export class AlgNextStepsComponent implements OnInit {
  public currentProduct: Product = {} as Product;
  constructor(private api: ApiService) { }

  ngOnInit() {
    this.api.currentProduct.subscribe((product: Product) => {
      this.currentProduct = product;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-next-steps/alg-next-steps.component.ts